/**
 * Finder-style list selection click math (plain / cmd|ctrl toggle / shift range).
 * Shared by the Workspaces/Skills rail selection store and kept in sync with
 * the canvas explorer's `useCanvasRailSelection` rules.
 */

export type ListSelectionClickResult = {
  next: Set<string>;
  /** Anchor for the next shift-range. Unchanged on a successful shift-range. */
  anchor: string | null;
};

export function computeListSelectionClick(params: {
  id: string;
  e: Pick<MouseEvent, "metaKey" | "ctrlKey" | "shiftKey">;
  selectedIds: Set<string>;
  orderedIds: string[];
  anchor: string | null;
}): ListSelectionClickResult {
  const { id, e, selectedIds, orderedIds, anchor } = params;

  if (e.metaKey || e.ctrlKey) {
    const next = new Set(selectedIds);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    return { next, anchor: id };
  }

  if (e.shiftKey && anchor) {
    const a = orderedIds.indexOf(anchor);
    const b = orderedIds.indexOf(id);
    if (a !== -1 && b !== -1) {
      const start = Math.min(a, b);
      const end = Math.max(a, b);
      return {
        next: new Set(orderedIds.slice(start, end + 1)),
        anchor,
      };
    }
  }

  return { next: new Set([id]), anchor: id };
}
